module.exports = __webpack_public_path__ + "static/media/tooth.fb37b94a.svg";